import styles from "./contact-us.module.scss";

const StoreDetails = () => {
  return (
    <div className={styles["details-container"]}>
      <h5 className={styles["contact-header"]}>Contact Information</h5>

      <div className={styles["contact-grid"]}>
        <div className={styles["contact-card"]}>
          <span className={styles["contact-label"]}>Hours</span>
          <div className={styles["hours-list"]}>
            <p>Sunday & Monday — CLOSED</p>
            <p>Tuesday – Friday — 9:00am – 7:00pm</p>
            <p>Saturday — 10:00am – 6:00pm</p>
          </div>
        </div>

        <div className={styles["contact-card"]}>
          <span className={styles["contact-label"]}>Email</span>
          <a href="mailto:management@merakiloungesd.com">management@merakiloungesd.com</a>
        </div>

        <div className={styles["contact-card"]}>
          <span className={styles["contact-label"]}>Book an Appointment</span>
          <a href="tel:+1 (619) 535-7828">+1 (619) 535-7828</a>
        </div>
      </div>

      <h5 className={styles["info-header"]}>More Information</h5>
    </div>
  );
};

export default StoreDetails;
